// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4b53f739","240":"313f5b7e","241":"3761c700","300":"21f2244b","505":"1a2e1093","696":"873dfdf7","805":"e50717da","885":"57ee9f4e","996":"e3e423ff"}[chunkId] + ".chunk.js";
};